require("./later");
module.exports = later;


/*****************
 ** WEBPACK FOOTER
 ** ./~/later/index-browserify.js
 ** module id = 52
 ** module chunks = 0 1
 **/